import { NavigationItem, NavigationSection } from '../domain/navigation';

const containsItem = (item: NavigationItem, itemId: string): boolean =>
    item.id === itemId ||
    Boolean(item.children?.some((child) => containsItem(child, itemId)));

export const getExpandedNavigationIds = (
    sections: NavigationSection[],
    activeItemId?: string,
): string[] => {
    if (!activeItemId) {
        return [];
    }

    return sections.flatMap((section) =>
        section.items
            .filter(
                (item) =>
                    item.id !== activeItemId &&
                    containsItem(item, activeItemId),
            )
            .map((item) => item.id),
    );
};
